

// redux/reducers/taskAdminReducers.js
import {
  FETCH_DESIGNATIONS_REQUEST,
  FETCH_DESIGNATIONS_SUCCESS,
  FETCH_DESIGNATIONS_FAILURE,
  FETCH_LOCATIONS_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
  FETCH_TASKS_LIST_REQUEST,
  FETCH_TASKS_LIST_SUCCESS,
  FETCH_TASKS_LIST_FAILURE,
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  CREATE_TASK_SUBMIT_REQUEST,
  CREATE_TASK_SUBMIT_SUCCESS,
  CREATE_TASK_SUBMIT_FAILURE,
} from "../actions/CreateTasksAdminActions";

const initialState = {
  designations: [],
  locations: [],
  tasksList: [],
  employeesByDesignation: {}, // {designation: [employees]}
  loading: false,
  error: null,
  success: false,
};

const taskAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DESIGNATIONS_REQUEST:
    case FETCH_LOCATIONS_REQUEST:
    case FETCH_TASKS_LIST_REQUEST:
    case FETCH_EMPLOYEES_REQUEST:
    case CREATE_TASK_SUBMIT_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_DESIGNATIONS_SUCCESS:
      return { ...state, loading: false, designations: action.payload };
    case FETCH_LOCATIONS_SUCCESS:
      return { ...state, loading: false, locations: action.payload };
    case FETCH_TASKS_LIST_SUCCESS:
      return { ...state, loading: false, tasksList: action.payload };
    case FETCH_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesByDesignation: {
          ...state.employeesByDesignation,
          [action.payload.designation]: action.payload.employees,
        },
      };

    case CREATE_TASK_SUBMIT_SUCCESS:
      return { ...state, loading: false, success: true };

    case FETCH_DESIGNATIONS_FAILURE:
    case FETCH_LOCATIONS_FAILURE:
    case FETCH_TASKS_LIST_FAILURE:
    case FETCH_EMPLOYEES_FAILURE:
    case CREATE_TASK_SUBMIT_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    default:
      return state;
  }
};

export default taskAdminReducer; // ✅ Export as default
